import apiClient from './apiClient'
import type { QuickReply } from '../types/quickReply.types'

export const quickReplyService = {
  async getQuickReplies(): Promise<{ success: boolean; data: QuickReply[]; message?: string }> {
    const response = await apiClient.get('/quick-replies')
    return response.data
  },

  async createQuickReply(payload: { title: string; content: string }): Promise<{ success: boolean; data?: QuickReply; message?: string }> {
    const response = await apiClient.post('/quick-replies', payload)
    return response.data
  },

  async updateQuickReply(id: number, payload: { title?: string; content?: string }): Promise<{ success: boolean; data?: QuickReply; message?: string }> {
    const response = await apiClient.put(`/quick-replies/${id}`, payload)
    return response.data
  },

  async deleteQuickReply(id: number): Promise<{ success: boolean; message?: string }> {
    const response = await apiClient.delete(`/quick-replies/${id}`)
    return response.data
  }
}

